module.exports = __webpack_public_path__ + "img/ifi.3a9064fb.png";